import { render, staticRenderFns } from "./freeMarketUpdate.vue?vue&type=template&id=76764439&"
import script from "./freeMarketUpdate.vue?vue&type=script&lang=js&"
export * from "./freeMarketUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports